module.exports = "<div class=\"dialog-modal\" ng-style=\"$ctrl.position\" ng-class=\"{active:$ctrl.isActive}\">\n    <div class=\"content\" ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.text)\"></div>\n    <div class=\"footer clearfix\">\n        <button class=\"btn btn-primary btn-sm pull-left\" ng-click=\"$ctrl.sure();\">{{'modal-text001' | translate}}</button>\n        <button class=\"btn btn-default btn-sm pull-right\" ng-click=\"$ctrl.isActive=false;$event.stopPropagation();\">{{'modal-text002' | translate}}</button>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/dialog-modal/dialog-modal.html
// module id = 715
// module chunks = 3